export enum APPOINTMENT_REQUEST_TYPE {
  NEW = 'N',
  FROM_ORDER = 'O',
  RESCHEDULE = 'R',
}
